import { makeObservable, observable, action } from "mobx";
import {
  ActivePaymentMethod,
  ActiveOption,
  InputsValues,
} from "../types/ExchangeInterface";

class ExchangeInterfaceStore {
  activePaymentMethod: ActivePaymentMethod = "USDT";
  activeOption: ActiveOption = "BUY";
  inputsValues: InputsValues = {
    baseCoinsToPay: "",
    pepeCoinsToReceive: "",
  };
  statuses = {
    WRONG_NETWORK: false,
    WALLET_DISCONNECTED: false,
    NOT_ENOUGH_ALLOWANCE: false,
    NOT_ENOUGH_BALANCE: false,
    NOT_ENOUGH_FEES: false,
    NOT_ENOUGH_TOKENS: false,
    NOTHING_TO_CLAIM: false,
    LOADING: false,
    PRESALE_ENDED: false,
    VESTING_STARTED: false,
    BELOW_MINIMUM: false
  }
  referrer: string = "0x0000000000000000000000000000000000000000";

  constructor() {
    makeObservable(this, {
      activePaymentMethod: observable,
      activeOption: observable,
      inputsValues: observable,
      statuses: observable,
      referrer: observable,
      setActivePaymentMethod: action,
      setActiveOption: action,
      setInputsValues: action,
      setStatus: action,
      setReferrer: action
    });
    
  }

  setStatus = (statusName: keyof typeof this.statuses, newValue: boolean) => {
    this.statuses[statusName] = newValue;
  };

  setActiveOption = (newValue: ActiveOption) => {
    this.activeOption = newValue;
  };
  setActivePaymentMethod = (newValue: ActivePaymentMethod) => {
    this.activePaymentMethod = newValue;
  };
  setInputsValues = (newValue: InputsValues) => {
    this.inputsValues = newValue;
  };
  setReferrer = (referrer: string)=> {
    this.referrer = referrer;
  }
}
const exchangeInterfaceStore = new ExchangeInterfaceStore();

export default exchangeInterfaceStore;
